import { getFoojiMicrositeDomain } from "../constants/provider";

export const getDomain = () => {
  console.log("Getting the domain for env ...", (import.meta.env.FOOJI_NODE_ENV as string));
  if ((import.meta.env.FOOJI_NODE_ENV as string) === "development") {
    console.log("Getting the development domain ...");
    // If testing using demo, it doesn't matter what the domain is
    // If testing using test or live, we need to match the domain of the campaign we're testing against
    // so we should set the FOOJI_MICROSITE_DOMAIN env var before running
    // We don't build this because we could be using a custom domain.
    return (import.meta.env.FOOJI_MICROSITE_DOMAIN as string) ?? document.location.host;
  }

  return getFoojiMicrositeDomain();
};
